import Login from '../componentes/Login/Login';

function Home() {
  return (
    <Login />
  );
}

export default Home;
